import { createSlice } from "@reduxjs/toolkit";
import {
  getComapnyList,
  changeCompanyStatus,
  getComapnyDetails,
} from "./companyAction";

const initialState = {
  data: null,
  loading: false,
  error: null,
  changeStatusLoading: false,
  changeStatusError: null,
  companyDetails: null,
};

const companySlice = createSlice({
  name: "comapny",
  initialState,
  reducers: {
    resetError(state) {
      state.error = null;
      state.changeStatusError = null;
    },
  },

  extraReducers: (builder) => {
    builder
      // Handle getComapnyList actions
      .addCase(getComapnyList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getComapnyList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getComapnyList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle changeCompanyStatus actions
      .addCase(changeCompanyStatus.pending, (state) => {
        state.changeStatusLoading = true;
        state.changeStatusError = null;
      })
      .addCase(changeCompanyStatus.fulfilled, (state, action) => {
        state.changeStatusLoading = false;
        // Optional: Update company data if the status change affects the list
        const updatedCompany = action.payload;
        if (state.data?.companies) {
          state.data.companies = state.data.companies.map((company) =>
            company.id === updatedCompany.id ? updatedCompany : company
          );
        }
      })
      .addCase(changeCompanyStatus.rejected, (state, action) => {
        state.changeStatusLoading = false;
        state.changeStatusError = action.payload;
      })

      .addCase(getComapnyDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getComapnyDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.companyDetails = action.payload;
      })
      .addCase(getComapnyDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError } = companySlice.actions;

export default companySlice.reducer;
